import React from 'react';
import P from 'prop-types';
import { Button } from '../Button';
import { FormataValor } from '../../utils/utils';

export const FinalizacaoRodape = ({ onClick, isPagOnline, valor, isCompleted }) => {
  const css = isPagOnline ? ' btnPaymentGreen ' : ' btnFinalizar ';
  return (
    <div className="container padTop20 padBottom20">
      <Button
        //type={isPagOnline ? 'submit' : 'button'}
        onClick={onClick}
        className={`btn_1 full-width mb_5  ${css} ${!isCompleted && !isPagOnline ? ' btnDisabled' : ''}`}
        text={`${isPagOnline ? 'Pagar' : 'Fazer Pedido'}`}
        textAlign={`${isPagOnline ? 'left' : 'center'}`}
        text2={`${isPagOnline ? FormataValor(valor) : ''}`}
        text2Align={`${isPagOnline ? 'right' : ''}`}
      />
    </div>
  );
};

FinalizacaoRodape.propTypes = {
  onClick: P.func,
  isPagOnline: P.oneOfType([P.bool, P.number]),
  isCompleted: P.bool,
  valor: P.oneOfType([P.string, P.number]),
};
